var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 106,
    viewBox: "0 0 233 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.046,
    y: 94.7051,
    width: 221.12,
    height: 65.7524,
    transform: "rotate(-180 228.046 94.7051)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201.159,
    y: 101.517,
    width: 186.642,
    height: 10.9208,
    transform: "rotate(-180 201.159 101.517)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 220.981,
    y: 100.455,
    width: 21.1437,
    height: 10.9208,
    transform: "rotate(-180 220.981 100.455)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 223.392,
    y: 97.0571,
    width: 8.40934,
    height: 10.9208,
    transform: "rotate(-180 223.392 97.0571)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.508,
    y: 41.3789,
    width: 8.40934,
    height: 14.1179,
    transform: "rotate(-180 225.508 41.3789)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 183.719,
    y: 24.3838,
    width: 7.80808,
    height: 18.7712,
    transform: "rotate(-180 183.719 24.3838)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 178.486,
    y: 28.6978,
    width: 7.80808,
    height: 18.7712,
    transform: "rotate(-180 178.486 28.6978)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 173.969,
    y: 36.647,
    width: 7.80808,
    height: 18.7712,
    transform: "rotate(-180 173.969 36.647)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3105,
    y: 97.1177,
    width: 7.80808,
    height: 10.9208,
    transform: "rotate(-180 17.3105 97.1177)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0542,
    y: 38.438,
    width: 7.80808,
    height: 14.1179,
    transform: "rotate(-180 19.0542 38.438)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 218.654,
    y: 35.6929,
    width: 202.21,
    height: 14.1179,
    transform: "rotate(-180 218.654 35.6929)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.363 22.0845L185.684 22.0845L185.684 4.74965L181.363 4.74965L181.363 22.0845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.042 4.75L181.363 4.75L181.363 0.435902L177.042 0.435901L177.042 4.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.643 9.14209L176.964 9.14209L176.964 4.82799L172.643 4.82799L172.643 9.14209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.322 13.4561L172.643 13.4561L172.643 9.14196L168.322 9.14196L168.322 13.4561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.001 17.7705L168.322 17.7705L168.322 13.4564L164.001 13.4564L164.001 17.7705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.602 22.0845L163.923 22.0845L163.923 17.7704L159.602 17.7704L159.602 22.0845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4067 22.0845L163.923 22.0845L163.923 17.7704L13.4067 17.7704L13.4067 22.0845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.719 22.0845L215.538 22.0845L215.538 17.7704L183.719 17.7704L183.719 22.0845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4068 104.651L216.773 104.651L216.773 100.337L13.4068 100.337L13.4068 104.651Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.366226 91.8247L4.68726 91.8247L4.68726 30.7911L0.366233 30.7911L0.366226 91.8247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08571 100.337L13.4067 100.337L13.4067 96.0228L9.08571 96.0228L9.08571 100.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7654 95.9448L9.08643 95.9448L9.08643 91.6307L4.7654 91.6307L4.7654 95.9448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08571 26.4771L13.4067 26.4771L13.4067 22.163L9.08571 22.163L9.08571 26.4771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7654 30.791L9.08643 30.791L9.08643 26.4769L4.7654 26.4769L4.7654 30.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.688 91.7466L230.01 91.7466L230.01 30.713L225.688 30.713L225.688 91.7466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.969 100.259L221.29 100.259L221.29 95.9452L216.969 95.9452L216.969 100.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.368 95.8662L225.689 95.8662L225.689 91.5521L221.368 91.5521L221.368 95.8662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.969 26.3989L221.29 26.3989L221.29 22.0848L216.969 22.0848L216.969 26.3989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.368 30.7124L225.689 30.7124L225.689 26.3983L221.368 26.3983L221.368 30.7124Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.719 22.8687L188.04 22.8687L188.04 5.53383L183.719 5.53383L183.719 22.8687Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.399 5.53369L183.72 5.53369L183.72 1.21959L179.399 1.21959L179.399 5.53369Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.999 9.92676L179.32 9.92676L179.32 5.61266L174.999 5.61266L174.999 9.92676Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.679 14.2407L175 14.2407L175 9.92662L170.679 9.92662L170.679 14.2407Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.358 18.5547L170.679 18.5547L170.679 14.2406L166.358 14.2406L166.358 18.5547Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.959 22.8687L166.28 22.8687L166.28 18.5546L161.959 18.5546L161.959 22.8687Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7634 22.8686L166.28 22.8687L166.28 18.5546L15.7634 18.5545L15.7634 22.8686Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.507 22.8686L219.326 22.8687L219.326 18.5546L187.507 18.5546L187.507 22.8686Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9595 105.436L219.326 105.436L219.326 101.121L15.9595 101.121L15.9595 105.436Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72292 92.4146L7.04395 92.4146L7.04395 31.3809L2.72292 31.3809L2.72292 92.4146Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 101.122L15.7639 101.122L15.7639 96.8075L11.4429 96.8075L11.4429 101.122Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12184 96.729L11.4429 96.729L11.4429 92.4149L7.12184 92.4149L7.12184 96.729Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4429 27.2617L15.7639 27.2617L15.7639 22.9476L11.4429 22.9476L11.4429 27.2617Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12184 31.5757L11.4429 31.5757L11.4429 27.2616L7.12184 27.2616L7.12184 31.5757Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.045 92.3369L232.366 92.3369L232.366 31.3033L228.045 31.3033L228.045 92.3369Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.325 101.043L223.646 101.043L223.646 96.7294L219.325 96.7294L219.325 101.043Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.725 96.6504L228.046 96.6504L228.046 92.3363L223.725 92.3363L223.725 96.6504Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.325 27.1831L223.646 27.1831L223.646 22.869L219.325 22.869L219.325 27.1831Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.725 31.4971L228.046 31.4971L228.046 27.183L223.725 27.183L223.725 31.4971Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5942 54.3926V41.0592H28.1498V54.3926H23.7053V38.837H37.0387V54.3926H32.5942ZM43.6966 52.1704H48.1411V45.5037H43.6966V52.1704ZM41.4744 52.1704H39.2522V45.5037H41.4744V43.2815H52.5855V54.3926H41.4744V52.1704ZM63.688 54.3926V45.5037H59.2435V54.3926H54.7991V43.2815H68.1324V54.3926H63.688ZM70.3459 54.3926V43.2815H74.7904V47.7259H77.0126V45.5037H79.2348V43.2815H83.6793V45.5037H81.4571V47.7259H79.2348V49.9481H81.4571V52.1704H83.6793V54.3926H79.2348V52.1704H77.0126V49.9481H74.7904V54.3926H70.3459ZM90.3373 52.1704H94.7817V45.5037H90.3373V52.1704ZM88.115 52.1704H85.8928V45.5037H88.115V43.2815H99.2262V54.3926H88.115V52.1704Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2757 74.248H25.609V72.6924H30.2757V74.248ZM25.609 80.4702V83.5813H24.0535V74.248H25.609V78.9147H30.2757V80.4702H25.609ZM31.8312 78.9147H30.2757V74.248H31.8312V78.9147ZM34.9469 78.9147H33.3914V74.248H34.9469V78.9147ZM39.6136 75.8035H38.058V74.248H39.6136V72.6924H41.1691V80.4702H39.6136V78.9147H38.058V77.3591H39.6136V75.8035ZM38.058 80.4702H34.9469V78.9147H38.058V80.4702ZM38.058 74.248H34.9469V72.6924H38.058V74.248ZM50.507 78.9147H48.9515V75.8035H50.507V78.9147ZM48.9515 71.1369H44.2848V69.5813H48.9515V71.1369ZM44.2848 75.8035H45.8404V77.3591H44.2848V78.9147H42.7292V71.1369H44.2848V75.8035ZM48.9515 80.4702H44.2848V78.9147H48.9515V80.4702ZM48.9515 75.8035H45.8404V74.248H48.9515V75.8035ZM53.6227 78.9147H52.0671V74.248H53.6227V78.9147ZM58.2894 74.248H53.6227V72.6924H58.2894V74.248ZM59.8449 78.9147H58.2894V74.248H59.8449V78.9147ZM58.2894 80.4702H53.6227V78.9147H58.2894V80.4702ZM66.0717 74.248V80.4702H64.5161V74.248H61.405V72.6924H69.1828V74.248H66.0717ZM72.2985 78.9147H70.7429V74.248H72.2985V78.9147ZM76.9651 75.8035H75.4096V74.248H76.9651V72.6924H78.5207V80.4702H76.9651V78.9147H75.4096V77.3591H76.9651V75.8035ZM75.4096 80.4702H72.2985V78.9147H75.4096V80.4702ZM75.4096 74.248H72.2985V72.6924H75.4096V74.248ZM86.2985 78.9147H84.7429V74.248H86.2985V78.9147ZM92.5207 74.248H86.2985V72.6924H92.5207V74.248ZM92.5207 80.4702H86.2985V78.9147H92.5207V80.4702ZM100.298 80.4702V82.0258H98.7429V78.9147H100.298V74.248H101.854V78.9147H104.965V74.248H106.521V78.9147H108.076V82.0258H106.521V80.4702H100.298ZM104.965 74.248H101.854V72.6924H104.965V74.248ZM111.181 78.9147H109.626V74.248H111.181V78.9147ZM115.848 74.248H111.181V72.6924H115.848V74.248ZM117.404 78.9147H115.848V74.248H117.404V78.9147ZM115.848 80.4702H111.181V78.9147H115.848V80.4702ZM120.519 77.3591V80.4702H118.964V72.6924H120.519V75.8035H123.63V77.3591H120.519ZM126.741 80.4702H125.186V78.9147H126.741V80.4702ZM125.186 78.9147H123.63V77.3591H125.186V78.9147ZM126.741 74.248H125.186V72.6924H126.741V74.248ZM125.186 75.8035H123.63V74.248H125.186V75.8035ZM136.079 77.3591H134.524V72.6924H136.079V77.3591ZM134.524 77.3591V80.4702H132.968V78.9147H129.857V77.3591H134.524ZM129.857 77.3591H128.302V72.6924H129.857V77.3591ZM132.968 82.0258H128.302V80.4702H132.968V82.0258ZM142.306 78.9147H140.751V75.8035H142.306V78.9147ZM143.862 74.248V72.6924H145.417V80.4702H143.862V75.8035H142.306V74.248H143.862ZM139.195 75.8035V80.4702H137.639V72.6924H139.195V74.248H140.751V75.8035H139.195ZM153.2 74.248H148.533V72.6924H153.2V74.248ZM148.533 77.3591V78.9147H146.977V74.248H148.533V75.8035H153.2V74.248H154.755V77.3591H148.533ZM154.755 80.4702H148.533V78.9147H154.755V80.4702ZM157.871 77.3591V80.4702H156.315V72.6924H157.871V75.8035H162.537V72.6924H164.093V80.4702H162.537V77.3591H157.871ZM170.32 74.248V80.4702H168.764V74.248H165.653V72.6924H173.431V74.248H170.32ZM176.547 78.9147H174.991V74.248H176.547V78.9147ZM181.213 75.8035H179.658V74.248H181.213V72.6924H182.769V80.4702H181.213V78.9147H179.658V77.3591H181.213V75.8035ZM179.658 80.4702H176.547V78.9147H179.658V80.4702ZM179.658 74.248H176.547V72.6924H179.658V74.248ZM188.996 78.9147H187.44V75.8035H188.996V78.9147ZM190.551 74.248V72.6924H192.107V80.4702H190.551V75.8035H188.996V74.248H190.551ZM185.884 75.8035V80.4702H184.329V72.6924H185.884V74.248H187.44V75.8035H185.884ZM195.222 78.9147V80.4702H193.667V72.6924H195.222V77.3591H196.778V78.9147H195.222ZM199.889 74.248V72.6924H201.445V80.4702H199.889V75.8035H198.333V74.248H199.889ZM198.333 77.3591H196.778V75.8035H198.333V77.3591Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDesc);
export default __webpack_public_path__ + "static/media/folderDesc.99afbae8e68c7809c2812a4bfc1b06d5.svg";
export { ForwardRef as ReactComponent };